import { api } from "./api";

export const register = async (username, email, password, role) => {
    try {
        const response = await api.post('auth/register', {
            username,
            email,
            password,
            role,
            status: '1',
        });

        if (response.data.token) {
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('token', response.data.token);
        }

        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const login = async (email, password, device) => {
    try {
        const response = await api.post('auth/login', {
            email,
            password,
            browser: device?.browser,
            os: device?.os,
            ip: device?.ip,
            deviceType: device?.deviceType,
            screenResolution: device?.screenResolution,
            status: '1',
        });

        if (response.data.token) {
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('token', response.data.token);
        }

        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
};

export const getCurrentUser = () => {
    const user = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    return user ? { ...JSON.parse(user), token } : null;
};

export const isAdmin = () => {
    const user = getCurrentUser();
    return user?.role === 'admin';
};

export const isAuthenticated = () => {
    const user = getCurrentUser();
    return !!user;
};